import React from "react";
import Avatar from "@mui/material/Avatar";
import { Tooltip } from "@mui/material";

interface EmailAvatarProps {
  email: string;
  size?: number;
}

const defaultColors: string[] = [
  "#1abc9c",
  "#3498db",
  "#f1c40f",
  "#8e44ad",
  "#e74c3c",
  "#d35400",
  "#2c3e50",
  "#7f8c8d",
];

export function calculateAsciiCode(value: string): number {
  return value
    .split("")
    .map((letter) => letter.charCodeAt(0))
    .reduce((previous, current) => previous + current, 0);
}

export function getRandomColor(avatarText?: string): string {
  if (!avatarText) {
    return "transparent";
  }
  const asciiCodeSum = calculateAsciiCode(avatarText);
  return defaultColors[asciiCodeSum % defaultColors.length];
}

const EmailAvatar: React.FC<EmailAvatarProps> = ({ email, size = 24 }) => {
  const bgColor = getRandomColor(email);
  const initials = email.includes(".")
    ? email
        .split(".")
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase()
    : email.slice(0, 2).toUpperCase();

  return (
    <Tooltip title={email} arrow placement="top">
      <Avatar
        alt={email}
        sx={{ width: size, height: size }}
        style={{ backgroundColor: bgColor, fontSize: ".9rem" }}
      >
        {initials}
      </Avatar>
    </Tooltip>
  );
};

export default EmailAvatar;
